import React from 'react';
import {Card, CardContent, Checkbox, FormControlLabel, IconButton, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import {Facebook, Google, Twitter} from "@mui/icons-material";
import Link from "@mui/material/Link";
import Avatar from "@mui/material/Avatar";
import shadows from "@mui/material/styles/shadows";
import {alpha} from "@mui/material/styles";
// import {auth} from "@jumbo/services/auth/firebase/firebase";
import * as yup from 'yup';
import {Form, Formik} from "formik";
// import {useAuthSignInWithEmailAndPassword} from "@react-query-firebase/auth";
import LoadingButton from "@mui/lab/LoadingButton";
import {useNavigate} from "react-router-dom";
import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import {ASSET_AVATARS, ASSET_IMAGES} from "../../../utils/constants/paths";
import {getAssetPath} from "../../../utils/appHelpers";
import authServices from 'app/services/auth-services';
import { takeReturnPath } from 'app/utils/afterLogin';
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Logo from 'app/shared/Logo';
import { getTenantBranding } from "app/utils/tenantBranding";

const validationSchema = yup.object({
    email: yup
        .string('Ingresa tu email')
        .email('Debes ingresar un email válido')
        .required('Debes ingresar un email'),
    password: yup
        .string('Ingresa tu contraseña')
        .required('Debes ingresar una contraseña'),
});

const Login = () => {
    const {setAuthToken} = useJumboAuth();
    const navigate = useNavigate();
    const tenantBranding = getTenantBranding();

    const onSignIn = (data, {setSubmitting}) => {
        authServices.signIn(data)
            .then((data) => {
                setAuthToken(data?.headers?.authorization);
                navigate(takeReturnPath() || "/");
                setSubmitting(false);
            })
            .catch((err) => {
                setSubmitting(false);
            });
    };

    //temp
    // const mutation = {isError: false};
    return (
        <Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: theme => theme.spacing(4),
        }}>
            <Logo sx={{mb: 3}} logo_url={tenantBranding.authLogoUrl} img_style={{maxHeight: '48px'}} />
            <Card sx={{maxWidth: '100%', width: 360, mb: 4}}>
                <Div sx={{position: 'relative', height: '200px'}}>
                    <CardMedia
                        component="img"
                        alt="banner-1"
                        height="200"
                        image={`${ASSET_IMAGES}/static/banner-1.jpg`}
                    />
                    <Div
                        sx={{
                            flex: 1,
                            inset: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: theme => alpha(theme.palette.common.black, .5),
                            p: theme => theme.spacing(3),
                        }}
                    >
                        <Typography
                            variant={"h2"}
                            sx={{
                                color: 'common.white',
                                fontSize: '1.5rem',
                                mb: 0
                            }}
                        >
                            Inicia sesión
                        </Typography>
                    </Div>
                </Div>
                <CardContent sx={{pt: 0}}>

                    <Formik
                        validateOnChange={true}
                        initialValues={{
                            email: '',
                            password: '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={onSignIn}
                    >
                        {({isSubmitting}) => (
                            <Form style={{textAlign: 'left'}} noValidate autoComplete='off'>
                                <Avatar
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        marginLeft: 'auto',
                                        boxShadow: shadows[3],
                                        transform: 'translateY(-50%)',
                                    }}
                                />
                                {/* {mutation.isError && <p>{mutation.error.message}</p>} */}
                                <Div sx={{mb: 3, mt: 1}}>
                                    <JumboTextField
                                        fullWidth
                                        name="email"
                                        label="Email"
                                    />
                                </Div>
                                <Div sx={{mb: 2, mt: 1}}>
                                    <JumboTextField
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                    />
                                </Div>
                                <Typography
                                    textAlign={"right"}
                                    variant={"body1"}
                                >
                                    <Link underline="none" href="/auth/forgot-password">¿Olvidaste tu contraseña?</Link>
                                </Typography>
                                <Div sx={{mb: 1}}>
                                    <FormControlLabel control={<Checkbox/>} label="Recuérdame"/>
                                </Div>
                                <LoadingButton
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{mb: 3}}
                                    loading={isSubmitting}
                                >Ingresar</LoadingButton>
                                {/* <Typography textAlign={"center"} variant={"body1"} mb={1}>¿No tienes una cuenta?
                                    <Link underline="none" href="/auth/signup"> Regístrate</Link>
                                </Typography> */}
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
            {/* <Typography variant={"body1"} mb={2}>O regístrate con</Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                    sx={{
                        bgcolor: '#385196',
                        color: 'common.white',
                        p: theme => theme.spacing(1.25),

                        '&:hover': {
                            backgroundColor: '#385196',
                        }
                    }}
                    aria-label="Facebook"
                >
                    <Facebook fontSize={"small"}/>
                </IconButton>
                <IconButton
                    sx={{
                        bgcolor: '#00a8ff',
                        color: 'common.white',
                        p: theme => theme.spacing(1.25),

                        '&:hover': {
                            backgroundColor: '#00a8ff',
                        }
                    }}
                    aria-label="Twitter"
                >
                    <Twitter fontSize={"small"}/>
                </IconButton>
                <IconButton
                    sx={{
                        bgcolor: '#23272b',
                        color: 'common.white',
                        p: theme => theme.spacing(1.25),

                        '&:hover': {
                            backgroundColor: '#23272b',
                        }
                    }}
                    aria-label="Twitter"
                >
                    <Google fontSize="small"/>
                </IconButton>
            </Stack> */}
        </Div>
    );
};

export default Login;
